import styled from "styled-components";
import { motion } from "framer-motion";

export const Container = styled.div`
  position: relative;
  display: inline-flex;
  width: 22px;
  height: 22px;
  align-items: center;
  justify-content: center;

  ${({ $placeholder }) => $placeholder && `visibility: hidden;`}
`;

export const CircleButton = styled.button`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid
    ${({ theme, $completo }) =>
      $completo ? theme.successText || "#1f8a3a" : theme.border};
  background: ${({ theme, $completo }) =>
    $completo ? theme.successText || "#1f8a3a" : "transparent"};
  color: #ffffff;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.04em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  transition: transform 0.12s ease, border-color 0.12s ease;

  &:hover {
    border-color: ${({ theme, $completo }) =>
      $completo ? theme.successText || "#1f8a3a" : theme.accent};
    transform: scale(1.08);
  }

  ${({ $completo, theme }) =>
    !$completo &&
    `color: ${theme.textSecondary};`}
`;

export const Popover = styled(motion.div)`
  position: absolute;
  top: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  min-width: 220px;
  max-width: 280px;
  background: ${({ theme }) => theme.surface};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 8px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.18);
  padding: 10px 12px;
  z-index: 50;
  text-align: left;
  font-size: 12px;
  color: ${({ theme }) => theme.textPrimary};
  cursor: default;
`;

export const PopoverTitle = styled.div`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: ${({ theme }) => theme.textSecondary};
  margin-bottom: 6px;
`;

export const PopoverItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding: 4px 0;
  border-top: 1px solid ${({ theme }) => theme.border};
  font-size: 12px;
  line-height: 1.3;

  &:first-of-type {
    border-top: none;
  }

  strong {
    font-weight: 700;
    color: ${({ theme }) => theme.textPrimary};
  }
  span {
    font-size: 11px;
    color: ${({ theme }) => theme.textSecondary};
    word-break: break-word;
  }
`;

export const PopoverEmpty = styled.div`
  font-size: 11px;
  color: ${({ theme }) => theme.textSecondary};
  font-style: italic;
`;
